import styled from "styled-components";

const Container = styled.div`
  background-color: #f9f9f9;
  padding: 100px 0 170px 0;
  min-height: 735px;
  overflow: hidden;

  @media ${({ theme }) => theme.breakpoints.md} {
    width: 100vw;
    max-width: 100%;
    margin-left: 0px;
    padding: 100px 0;
  }
  @media ${({ theme }) => theme.breakpoints.sm} {
    padding: 50px 0;
  }
`;

const Form = styled.div`
  .hubspot-form {
    .form-columns-2 {
      max-width: 100%;
      width: 100%;
    }
  }
`;

const S = {
  Container,
  Form,
};

export default S;
